import { Button, Modal } from "react-bootstrap";

export default function AnalysisErrorModal({ error, onClose }) {
  if (!error) return null; // Don't render if no error

  return (
    <Modal show={!!error} onHide={onClose} centered>
      <Modal.Body className="text-center">
        <Modal.Title>{error.message}</Modal.Title>

        <p className="my-4">{error.description || "Please try again."}</p>

        <Button variant="danger" onClick={onClose}>
          Ok
        </Button>
      </Modal.Body>
    </Modal>
  );
}
